module.exports = __webpack_public_path__ + "img/centrum-koffiekaart-full.905ebab7.jpg";